import { Button, FormControl, Grid, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';


import InputForm from '../../../../partials/inputForm'
import Loading from '../../../loading';
import Snackbar from '../../../snackbar';
import { fanpageStyle } from './styles';


class Fanpage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fanpageId: '',
        };
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        })
    }
    handleSubmit = async () => {
        var { t } = this.props;
        const { fanpageId } = this.state;

        this.loading.startLoading()
        let check = await this.props.serviceDispatch.updateFanpageId(fanpageId)
        if (check.code === 1) {
            this.getFanpageId()
            this.mSnackbar.handleClick(t('fanpage_you_have_sent_it_successfully'));
        } else {
            this.setState({ fanpageId: '' })
            this.loading.stopLoading()
            this.mSnackbar.handleClick(t('fanpage_you_have_sent_it_Unsuccessfully') + ' ' + check.message, 'error');
        }
    }
    getFanpageId = async () => {
        const { service = {} } = this.props
        this.loading.startLoading()
        let check = await this.props.serviceDispatch.getFanpageId({ serviceCode: service.no });
        if (check.code === 1) {
            this.setState({ fanpageId: check.data ? check.data.fanpageId : '' })
        }
        else this.mSnackbar.handleClick(check.message, 'error');
        this.loading.stopLoading()
    }
    componentDidMount() {
        this.getFanpageId()
    }

    render() {
        const { classes, t, disabled = false } = this.props;
        const { fanpageId } = this.state;
        return (
            <div>
                <Snackbar
                    color='white'
                    onRef={snackbar => (this.mSnackbar = snackbar)}
                />
                <Loading onRef={id => (this.loading = id)} />



                <Grid container spacing={3} alignItems='center' justify='center'>
                    {/* <Grid item xs={12} sm={12} md={12}>
                        <Typography variant={'h4'} align='center'>Facebook Fanpage</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={12} md={12}>
                        <InputForm 
                            fullWidth
                            label={'Facebook ID'}
                            disabled={disabled}
                            value={fanpageId}
                            onChange={this.handleChange('fanpageId')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={12}>
                        <Button disabled={disabled} color="primary" size="large" variant="contained" className={classes.button} onClick={this.handleSubmit}>{t('fanpage_submit')} </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

Fanpage.propTypes = {};
const mapState = state => ({
    serviceState: state.service,
    role: state.user.user.roleId.role,
    ownerCode: state.service.service.userCode
})
const mapDispatch = dispatch => ({
    serviceDispatch: dispatch.service,
});
export default connect(mapState, mapDispatch)(translate('translations')(withStyles(fanpageStyle, { withTheme: 0 })(Fanpage)));
